import { IAgencyNumber, IAgencyNumbers } from '../../../features/configurations/store/configurations.types'
import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'

export const moveAgencyNumber = (pcr: IPcr): IPcr => {
  try {
    const agencyNumbers = pcr.agencyNumber

    if (Array.isArray(agencyNumbers)) {
      const updatedAgencyNumbers: IAgencyNumbers = {}

      agencyNumbers.forEach((agencyNumber: IAgencyNumber) => {
        updatedAgencyNumbers[agencyNumber.dataset] = agencyNumber.agencyNumber
      })

      pcr.agencyNumber = updatedAgencyNumbers
    }

    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade script moveAgencyNumber: ${error}`)
    throw error
  }
}
